import request from '@/utils/request'
import storage from 'store'

function getTenantId () {
  return storage.get('tenantId') || ''
}

// 查询阿里云配置
export function getAliyunKey (data) {
  const payload = { ...(data || { pageNum: 1, pageSize: 10 }), tenantId: getTenantId() }
  return request({
    url: '/manager/aliyun_key_config/getAliyunKey',
    method: 'get',
    params: payload
  })
}

// 添加/修改阿里云配置
export function addAliyunKey (data) {
  return request({
    url: '/manager/aliyun_key_config/addAliyunKey',
    method: 'post',
    data: { ...data, tenantId: data.tenantId ?? getTenantId() }
  })
}

// 删除阿里云配置
export function deleteAliyunKey (ids) {
  return request({
    url: '/manager/aliyun_key_config/delectAliyunKey',
    method: 'post',
    data: { ids, tenantId: getTenantId() }
  })
}

// 连通性测试（若后端提供）
export function testAliyunConnectivity (data) {
  const payload = { ...(data || {}) }
  // 如果调用方未显式传入 tenantId，则默认使用当前登录租户
  if (!payload.tenantId) {
    payload.tenantId = getTenantId()
  }
  return request({
    url: '/manager/aliyun_key_config/testConnection',
    method: 'post',
    data: payload
  })
}

// 同步阿里云模板（GET /manager/aliyunTemplate/syncAliyunTemplate）
export function syncAliyunTemplates () {
  return request({
    url: '/manager/aliyunTemplate/syncAliyunTemplate',
    method: 'get'
  })
}

// 查询阿里云模板列表（GET /manager/aliyunTemplate/selectAliyunTemplateByTenantId）
export function getAliyunTemplates (params = {}) {
  const payload = { pageNum: 1, pageSize: 10, ...params }
  return request({
    url: '/manager/aliyunTemplate/selectAliyunTemplateByTenantId',
    method: 'get',
    params: payload
  })
}
/**
 * 获取用户选择记录
 * @param {Object} params - { userTemplateId, waterTemplateId }
 */
export function getSysUserMsg (params = {}) {
  return request({
    url: '/manager/SysUserMsg/selectSysUserMsg',
    method: 'get',
    params
  })
}

/**
 * 添加/修改用户选择记录
 * @param {Object} data - { userIds, userTemplateId, waterTemplateId }
 */
export function addOrUpdateSysUserMsg (data = {}) {
  return request({
    url: '/manager/SysUserMsg/addOrUpdateSysUserMsg',
    method: 'post',
    data
  })
}